var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSubtract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "-1 -1 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 13v-2h12v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 23c-6.07513 0-11-4.9249-11-11h-2c0 7.1797 5.8203 13 13 13zm11-11c0 6.0751-4.9249 11-11 11v2c7.1797 0 13-5.8203 13-13zm-11-11c6.0751 0 11 4.92487 11 11h2c0-7.1797-5.8203-13-13-13zm0-2c-7.1797 0-13 5.8203-13 13h2c0-6.07513 4.92487-11 11-11z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubtract);
export default __webpack_public_path__ + "static/media/ic_subtract.979a6f73db65ab4c910b6f6665929794.svg";
export { ForwardRef as ReactComponent };